import React, { Component } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connect } from 'react-redux';
import { selectedRowPublicUrlSelector } from '../../selectors/admin/tables';
import { publicUrlSelector } from '../../selectors/admin/models/contracts';

class PopupMenu extends Component {
    _optionSelected = e => this.props.onOptionSelected(e.currentTarget.innerText, e.currentTarget.value);
    render() {
        const publicUrl = this.props.contractTablePublicUrl || this.props.contractFormPublicUrl;
        return (
            <Menu
                className="ckp-popup-menu"
                PaperProps={{
                    style: {
                        maxHeight: 350,
                        minWidth: this.props.minWidth || 0
                    }
                }}
                onClose={this.props.onClose}
                anchorEl={this.props.anchorElement}
                open={!!this.props.anchorElement}
            >
                {this.props.options.map((o, i) => {
                    return o === 'COPY PUBLIC LINK' ? (
                        <CopyToClipboard key={o} text={publicUrl}>
                            <MenuItem
                                disabled={this.props.disabled[i]}
                                className={`ckp-popup-menu-item`}
                                selected={this.props.selected === o}
                                key={o}
                                value={i}
                                onClick={this._optionSelected}
                            >
                                {o}
                            </MenuItem>
                        </CopyToClipboard>
                    ) : (
                        <MenuItem
                            disabled={this.props.disabled[i]}
                            className={`ckp-popup-menu-item`}
                            selected={this.props.selected === o}
                            key={o}
                            value={i}
                            onClick={this._optionSelected}
                        >
                            {o}
                        </MenuItem>
                    );
                })}
            </Menu>
        );
    }
}

const mapStateToProps = (state, props) => ({
    contractTablePublicUrl: selectedRowPublicUrlSelector(state, props),
    contractFormPublicUrl: publicUrlSelector(state, props)
});

PopupMenu.defaultProps = {
    options: [],
    disabled: []
};

// export default PopupMenu;

export default connect(mapStateToProps)(PopupMenu);
